import FlagIcon from 'components/elements/icons/FlagIcon'
import MainTemplate from 'components/templates/MainTemplate'
import React from 'react'
import Precautions from 'components/elements/items/Precautions'
import { QnStatesProps } from '../../states/QnState'
import { useServiceEndProcess } from '../../utils/commonHooks'

/**
 * QN-11-a: 位置共有終了画面
 */
export default function Joined(props: QnStatesProps): JSX.Element {
  useServiceEndProcess(props)

  return (
    <MainTemplate
      title={'スタッフの位置情報の\n共有を終了します'}
      icon={<FlagIcon />}
      content={<Precautions />}
      showContact={true}
      background={'rgba(240, 240, 240, 1.0)'}
    />
  )
}
